import script from "./ContentBlocks.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContentBlocks.vue?vue&type=script&lang=ts&setup=true"

import "./ContentBlocks.vue?vue&type=style&index=0&id=07f095ab&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07f095ab"]])

export default __exports__